// src/pages/Users/Inscription/components/SeasonTypePanel.jsx

import React from "react";
import { FaCalendarAlt } from "react-icons/fa";
import StepCard from "./StepCard";

export default function SeasonTypePanel({ saisonActive, value, onChange }) {
  return (
    <StepCard
      step="1"
      title="Saison & type d’inscription"
      icon={<FaCalendarAlt />}
      description="La saison est verrouillée automatiquement. Choisissez simplement le type d’inscription."
    >
      <div className="grid gap-4 lg:grid-cols-[260px_1fr]">
        <div className="rounded-3xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950/70">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500">
            Saison active
          </p>
          <p className="mt-2 text-2xl font-bold text-slate-950 dark:text-white">
            {saisonActive || "—"}
          </p>
        </div>

        <div className="rounded-3xl border border-slate-200 bg-slate-50 p-4 dark:border-slate-800 dark:bg-slate-950/70">
          <p className="text-xs font-bold uppercase tracking-[0.18em] text-slate-500">
            Type d’inscription *
          </p>

          <div className="mt-4 grid gap-3 sm:grid-cols-2">
            {[
              {
                label: "Cours d’essai",
                value: "Cours d'essai",
                detail: "Pour découvrir l’activité avant inscription complète.",
              },
              {
                label: "Inscription",
                value: "Inscrit",
                detail: "Pour créer une inscription classique sur la saison.",
              },
            ].map((item) => {
              const selected = value === item.value;

              return (
                <button
                  key={item.value}
                  type="button"
                  onClick={() => onChange(item.value)}
                  className={`rounded-3xl border p-4 text-left transition ${
                    selected
                      ? "border-[#013E8E] bg-indigo-50 ring-4 ring-indigo-500/10 dark:border-indigo-400 dark:bg-indigo-500/10"
                      : "border-slate-200 bg-white hover:bg-slate-50 dark:border-slate-700 dark:bg-slate-900 dark:hover:bg-slate-800"
                  }`}
                >
                  <span className="block text-base font-bold text-slate-950 dark:text-white">
                    {item.label}
                  </span>
                  <span className="mt-1 block text-sm leading-6 text-slate-600 dark:text-slate-300">
                    {item.detail}
                  </span>
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </StepCard>
  );
}